import React, { Component } from "react";
import PropTypes from "prop-types";
import SchemaForm from "./SchemaForm";
import FormUtils from "../lib/FormUtils";
import TypeUtils from "../lib/TypeUtils";
import utils from "../lib/utils";
import { connect } from "react-redux";
import { push } from "../history";
import { save, remove } from "../actions/users";
import { clear as clearSheets } from "../actions/sheets";

import Loading from "./Loading";
import InfoPopover from "./InfoPopover";
import Switch from "./fields/Switch";

@connect((state, props) => {
  if (props.role && props.model) return {};
  const {
    match: { params },
  } = props;
  const role = state.roles.filter((role) => role.slug === params.type).shift();

  if (!role || !state.users[role.id]) return {};

  const model = params.id
    ? state.users[role.id].filter((v) => v.id === params.id).shift()
    : {};

  return { role, model };
})
export default class EditUser extends Component {
  static contextTypes = {
    site: PropTypes.object,
    account: PropTypes.object,
  };

  state = {
    active: this.props.model ? this.props.model.active : false,
  };

  componentWillReceiveProps(props) {
    if (!props.model) return;

    if (this.props.model !== props.model.active) {
      this.setState({ active: props.model.active });
    }
  }

  getSchema() {
    const { model, role } = this.props;
    if (!role) return null;
    const partSchema = FormUtils.getContentSchema(role, model);

    // fixme - how to handle passwords for new/existing users?
    // if there is an existing user and we "set" a password
    //
    // const password = {
    //   type: 'password',
    //   label: 'Change Password',
    //   config: {size: 1, max: 1},
    //   attrs: {
    //     type: 'password',
    //     autoComplete: 'new-password'
    //   }
    // }

    return {
      email: {
        type: "email",
        required: true,
        config: { size: 1, max: 1, required: true },
      },
      ...partSchema,
    };
  }

  getValue({ model, role }) {
    return role.parts.reduce(
      (obj, part) => {
        obj[part.name] = model[part.name];
        return obj;
      },
      { email: model.email }
    );
  }

  onSubmit = async (value) => {
    const { model, role, isSheet, dispatch } = this.props;
    const data = { active: this.state.active, ...value };
    if (model.id) data.id = model.id;

    const {
      data: { user },
    } = await dispatch(save(data, role));

    if (isSheet) {
      dispatch(clearSheets());
    } else if (!model.id) {
      push(utils.contentUrl(user.id));
    }
  };

  onDelete = async (e) => {
    e.preventDefault();
    const { model, isSheet, dispatch, role } = this.props;
    await dispatch(remove(model, role));
    if (!isSheet) push(utils.contentUrl());
  };

  onDone = (e) => {
    e.preventDefault();
    const { dispatch, isSheet } = this.props;
    if (isSheet) {
      dispatch(clearSheets());
    } else {
      push(utils.contentUrl());
    }
  };

  onChangeActive = (checked) => {
    this.setState({ active: checked });
  };

  render() {
    const schema = this.getSchema();
    const { model, role } = this.props;

    if (!model) {
      return <Loading type="container" />;
    }

    let components = [
      <Switch
        key="active"
        value={this.state.active}
        onChange={this.onChangeActive}
      />,
    ];

    if (model.id) {
      components.push(<InfoPopover key="info" model={model} />);

      const isCurrentUser =
        this.context.account && this.context.account.user_id === model.id;
      const canDelete =
        (TypeUtils.can(this.context.site, role, "delete") ||
          TypeUtils.can(this.context.site, role, "delete", model.id)) &&
        !isCurrentUser;
      if (canDelete) {
        components.push(
          <a
            key="delete"
            className="btn-icon ion-ios-trash-outline btn-delete"
            onClick={this.onDelete}
          />
        );
      }
    }

    return (
      <div className="edit-content scroll-container">
        <SchemaForm
          schema={schema}
          value={model}
          onSubmit={this.onSubmit}
          onCancel={this.onDone}
          actionBar={(props) => components}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/EditUser.js